export function handleError(error: Response | any): Promise<any> {
    let errMsg: string;
  
    if (error instanceof Response) {
      const body = error.json() || '';
      const err = JSON.stringify(body);
      errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
    } else if (error.error) {
      errMsg = error?.error?.toString();
    } else {
      errMsg = error.message ? error.message : error.toString();
    }
  
    return Promise.reject(errMsg);
  }
  